export const environment = {
  production: false,
  envName: 'uat',
  host: 'https://test-api.setlog.com',
  basePath: '/services',
  version: require('../../package.json').version,
};
